import { render, staticRenderFns } from "./contacto.vue?vue&type=template&id=28afb8b0&scoped=true&"
import script from "./contacto.vue?vue&type=script&lang=js&"
export * from "./contacto.vue?vue&type=script&lang=js&"
import style0 from "./contacto.vue?vue&type=style&index=0&id=28afb8b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28afb8b0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsletterForm: require('/builds/marketing/abstracta.academy-website/components/NewsletterForm.vue').default,ContactForm: require('/builds/marketing/abstracta.academy-website/components/ContactForm.vue').default,HeaderMain: require('/builds/marketing/abstracta.academy-website/components/HeaderMain.vue').default})
